// extracted by mini-css-extract-plugin
module.exports = {"list-item":"i_WVmjWACxszq8qkijNC","player":"_1Qxexq5fjTuzrhk94kbb","goalkeeper":"_14T0a-6HzD6pw2UBPDB9","header":"_2KG3dyTzT6Vz937f1JrD"};